import { render, staticRenderFns } from "./IdeaIsSafeSection.vue?vue&type=template&id=9a97d23e&scoped=true"
import script from "./IdeaIsSafeSection.vue?vue&type=script&lang=js"
export * from "./IdeaIsSafeSection.vue?vue&type=script&lang=js"
import style0 from "./IdeaIsSafeSection.vue?vue&type=style&index=0&id=9a97d23e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a97d23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a97d23e')) {
      api.createRecord('9a97d23e', component.options)
    } else {
      api.reload('9a97d23e', component.options)
    }
    module.hot.accept("./IdeaIsSafeSection.vue?vue&type=template&id=9a97d23e&scoped=true", function () {
      api.rerender('9a97d23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/IdeaIsSafe/IdeaIsSafeSection.vue"
export default component.exports